/**
 * 隐藏积木块，一般用于隐藏一些不想让用户看到的积木块
 * @param {string} blockId - 需要隐藏的块的 id
 * @returns {promise} Promise
 */
export default function hideBlock (blockId) {
    return new Promise(resolve => {
        const find = document.querySelector(`[data-id="${blockId}"]`);
        if (find) {
            find.style.display = 'none';
        } else {
            console.error(`没有找到 data-id 为 ${blockId} 的块`);
        }
        resolve(true);
    });
}
